import Immutable from "seamless-immutable";
import {
  FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  GET_ME_FAILED,
  GET_ME_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED,
  FETCH_TEACHER_ENGAGEMENT_DATA_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_DATA_FAILED,
  FETCH_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_STUDENT_ENGAGEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_DATA_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_DATA_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED,
  FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
  FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED,
  FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
  FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED,
  EXIT_DASHBOARD_QUESTION_VIEW,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_IMPROVEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_QUESTION_COMPLETION_DATA_SUCCEEDED,
  FETCH_STUDENT_TIME_DATA_SUCCEEDED,
  RESET_CURRENT_QUESTION_VIEW_STUDENT,
  SET_CURRENT_QUESTION_VIEW_EXERCISE,
  SET_CURRENT_QUESTION_VIEW_STUDENT,
  FETCH_STUDENT_TIME_CHART_DATA_SUCCEEDED,
  FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED,
  FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED,
  FETCH_STUDENT_TIME_CHART_DATA_FAILED,
  FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED,
  FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED,
  FETCH_STUDENT_TIME_DATA_FAILED,
  FETCH_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
  FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
  FETCH_STUDENT_LIST_DROPDOWN_REQUESTED,
  FETCH_STUDENT_LIST_DROPDOWN_SUCCEEDED,
  SET_CURRENT_QUESTION_VIEW_STUDENT_CLASS,
  RESET_CURRENT_QUESTION_VIEW_STUDENT_CLASS,
  FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED,
  GET_USER_LOGIN_SUCCEEDED,
  GET_USER_LOGIN_FAILED,
  GET_USER_PASSWORD_LINK_SUCCEEDED,
  GET_USER_PASSWORD_LINK_FAILED,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_FAILED,
  GET_CHANGE_PASSWORD_SUCCEEDED,
  GET_CHANGE_PASSWORD_FAILED,
  VERIFY_RESET_CODE_SUCCEEDED,
  VERIFY_RESET_CODE_FAILED,
  USER_LOGGED_OUT_SUCCEEDED,
  GET_USER_LOGOUT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
  EXIT_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
  EXIT_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE,
  FETCH_DISTRICT_SCHOOLS_SUCCEEDED,
  FETCH_DISTRICT_SCHOOLS_FAILED,
  FETCH_DISTRICTS_FAILED,
  FETCH_DISTRICTS_SUCCEEDED,
  DOWNLOAD_DISTRICT_DATA_REQUESTED,
  DOWNLOAD_DISTRICT_DATA_SUCCEEDED,
  DOWNLOAD_DISTRICT_DATA_FAILED,
  DOWNLOAD_PAGINATION_DATA_REQUESTED,
  DOWNLOAD_PAGINATION_DATA_SUCCEEDED,
  DOWNLOAD_PAGINATION_DATA_FAILED,
  RESET_DOWNLOAD_PAGINATION_DATA,
  DOWNLOAD_ALL_MOE_REPORTS_REQUESTED,
  DOWNLOAD_ALL_MOE_REPORTS_SUCCEEDED,
  DOWNLOAD_ALL_MOE_REPORTS_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_SUCCEEDED,
} from "./action";

import { b64DecodeUnicode } from "./utils";
import { textIdentifier } from "./components/Common/textIdentifier";

export const initialState = Immutable({
  userSession: {
    user: undefined,
    tokenRefreshed: false, // true when jwt expires
    loggedOut: false,
    isAuthenticated: false,
  },
  changePassword: undefined,
  allSubjects: [],
  ministryDashboardOverviewData: undefined,
  teacherEngagementCount: undefined,
  teacherEngagementData: [],
  studentEngagementCount: undefined,
  studentEngagementData: [],
  studentProficientLvlTwoCount: undefined,
  studentProficientLvlTwoData: [],
  ministryQuestionsAttemptData: [],
  ministryStudentImprovementCount: [],
  ministryStudentImprovementData: [],
  teacherEngagementPercentageTableData: undefined,
  teacherEngagementHoursTableData: undefined,
  studentEngagementPercentageTableData: undefined,
  studentEngagementHoursTableData: undefined,
  studentProficientLvlTwoPercentTableData: undefined,
  studentProficientLvlTwoPercentTableData2: undefined,
  studentProficientLvlTwoNumberTableData: undefined,
  ministryQuestionsAttemptCount: undefined,
  ministryQuestionsAttemptedTableData: undefined,
  ministryStudentImprovementPercentageTableData: undefined,
  ministryStudentImprovementNumberTableData: undefined,
  studentDashboardOverviewData: undefined,
  studentTimeChartData: [],
  studentQuestionsCompletedChartData: [],
  studentImprovementChartData: [],
  studentQuestionsCompletedChartDataRoundTwo: [],
  studentImprovementChartDataRoundTwo: [],
  studentTimeData: undefined,
  studentQuestionCompletionData: undefined,
  studentImprovementData: undefined,
  studentQuestionCompletionDataRoundTwo: undefined,
  studentImprovementDataRoundTwo: undefined,
  studentDetailedImprovementData: undefined,
  studentReportQuestions: undefined,
  currentQuestionViewExercise: undefined,
  currentQuestionViewStudent: undefined,
  currentQuestionViewStudentClass: undefined,
  teacherDashboardOverviewData: undefined,
  teacherDashboardNationwideStudentEngagementCount: undefined,
  teacherDashboardNationwideStudentEngagementChart: [],
  teacherDashboardNationwideStudentProfLvlTwoCount: undefined,
  teacherDashboardNationwideStudentProfLvlTwoChart: [],

  teacherDashboardStudentEngagementCount: undefined,
  teacherDashboardStudentEngagementChart: [],
  teacherDashboardStudentCompletedTwentyQuestionsCount: undefined,
  teacherDashboardStudentCompletedTwentyQuestionsChart: [],

  teacherDashboardStudentProfLvlTwoCount: undefined,
  teacherDashboardStudentProfLvlTwoChart: [],
  teacherDashboardStudentImprovementCount: undefined,
  teacherDashboardStudentImprovementChart: [],
  teacherDashboardStudentProfLvlTwoTable: undefined,

  teacherDashboardStudentProfLvlTwoCountRoundTwo: undefined,
  teacherDashboardStudentProfLvlTwoChartRoundTwo: [],
  teacherDashboardStudentImprovementCountRoundTwo: undefined,
  teacherDashboardStudentImprovementChartRoundTwo: [],
  teacherDashboardStudentProfLvlTwoTableRoundTwo: undefined,

  teacherDashboardQuestionAnalysisTopics: [],
  teacherDashboardQuestionAnalysisChart: [],
  teacherDashboardQuestionAnalysisTable: undefined,

  teacherDashboardQuestionAnalysisTopicsRoundTwo: [],
  teacherDashboardQuestionAnalysisChartRoundTwo: [],
  teacherDashboardQuestionAnalysisTableRoundTwo: undefined,

  teacherDashboardStudentListDropdown: [],
  teacherDashboardStudentListDropdownRoundTwo: [],

  principalSchoolId: undefined,
  principalDashboardOverviewData: undefined,
  principalDashboardNationwideTeacherEngagementCount: undefined,
  principalDashboardNationwideTeacherEngagementChart: [],
  principalDashboardNationwideStudentEngagementCount: undefined,
  principalDashboardNationwideStudentEngagementChart: [],
  principalDashboardNationwideStudentProfLvlTwoCount: undefined,
  principalDashboardNationwideStudentProfLvlTwoChart: [],

  principalDashboardTeacherEngagementCount: undefined,
  principalDashboardTeacherEngagementChart: [],
  principalDashboardStudentEngagementCount: undefined,
  principalDashboardStudentEngagementChart: [],
  principalDashboardStudentCompletedTwentyQuestionsCount: undefined,
  principalDashboardStudentCompletedTwentyQuestionsChart: [],
  principalDashboardStudentCompletedTenQuestionsCount: undefined,
  principalDashboardStudentCompletedTenQuestionsChart: [],

  principalDashboardStudentProfLvlTwoCount: undefined,
  principalDashboardStudentProfLvlTwoChart: [],
  principalDashboardStudentImprovementCount: undefined,
  principalDashboardStudentImprovementChart: [],
  principalDashboardStudentProfLvlTwoTable: undefined,

  principalDashboardQuestionAnalysisTopics: [],
  principalDashboardQuestionAnalysisTopicsRoundTwo: [],
  principalDashboardQuestionAnalysisChart: [],
  principalDashboardQuestionAnalysisChartRoundTwo: [],
  principalDashboardQuestionAnalysisTable: undefined,

  principalDashboardStudentListDropdown: [],
  principalDashboardTeacherHoursTable: undefined,
  districtSchools: undefined,
  districts: undefined,
  downloadDistrictDataLoading: false,
  downloadDistrictDataSuccess: false,
  downloadDistrictDataError: false,
  downloadAllMoeReportsLoading: false,
  downloadAllMoeReportsSuccess: false,
  downloadAllMoeReportsError: false,
  downloadPaginationDataLoading: false,
  downloadPaginationDataSuccess: false,
  downloadPaginationDataError: false,
});

export default (state = initialState, action) => {
  if (action.resp && action.resp.hasOwnProperty("tokenRefreshed")) {
    const tokenRefreshed = action.resp.tokenRefreshed;
    state = state.merge({
      userSession: state.userSession.merge({
        tokenRefreshed: true,
      }),
    });
  }
  switch (action.type) {
    case GET_USER_LOGIN_SUCCEEDED:
      if (action.reset) {
        return state.merge({
          registerError: undefined,
          loginError: undefined,
        });
      }
      return state.merge({
        userSession: state.userSession.merge({
          user: action.data,
          tokenRefreshed: false,
          loggedOut: false,
          isAuthenticated: true,
          isMe: false,
        }),
        loginError: undefined,
      });
    case GET_USER_LOGIN_FAILED:
      if (action.data)
        return state.merge({
          loginError: action.data.nonFieldErrors.join(" "),
        });
      return state;
    case GET_USER_PASSWORD_LINK_SUCCEEDED:
      if (action.reset) {
        return state.merge({
          forgotPasswordSuccess: false,
          forgotPasswordError: false,
        });
      }
      return state.merge({
        forgotPasswordSuccess: "link-sent",
        forgotPasswordError: false,
      });
    case GET_USER_PASSWORD_LINK_FAILED:
      if (action.data) {
        return state.merge({
          forgotPasswordError: action.data.nonFieldErrors.join(" "),
          forgotPasswordSuccess: false,
        });
      }
      if (action.message) {
        return state.merge({
          forgotPasswordError: action.message,
        });
      }
      return state;
    case VERIFY_RESET_CODE_SUCCEEDED:
      return state.merge({
        verifyCodeSuccess: true,
        ...action.data,
      });
    case VERIFY_RESET_CODE_FAILED:
      return state.merge({
        verifyCodeError: action.data
          ? action.data.nonFieldErrors.join(" ")
          : action.message,
      });
    case RESET_PASSWORD_SUCCEEDED:
      if (action.reset) {
        return state.merge({
          resetPasswordSuccess: undefined,
          resetPasswordError: undefined,
        });
      }
      return state.merge({
        resetPasswordSuccess: action.data,
        resetPasswordError: undefined,
      });
    case RESET_PASSWORD_FAILED:
      return state.merge({
        resetPasswordError: action.data
          ? action.data.nonFieldErrors.join(" ")
          : action.message,
        resetPasswordSuccess: undefined,
      });
    case GET_CHANGE_PASSWORD_SUCCEEDED:
      return state.setIn(["changePassword"], "Password changed");
    case GET_CHANGE_PASSWORD_FAILED:
      return state.setIn(
        ["changePassword"],
        action.resp.data.non_field_errors[0]
      );
    case GET_USER_LOGOUT_SUCCEEDED:
      return initialState;
    case USER_LOGGED_OUT_SUCCEEDED:
      state = initialState;
      return state.merge({
        userSession: state.userSession.merge({
          user: undefined,
          tokenRefreshed: false,
          loggedOut: true,
          isAuthenticated: false,
        }),
      });
    case GET_ME_SUCCEEDED:
      // action.resp.data.language = 'ja';
      return state.merge({
        userSession: state.userSession.merge({
          user: action.resp.data,
          tokenRefreshed: false,
          loggedOut: false,
          isAuthenticated: true,
          isMe: true,
        }),
        allSubjects: action.resp.data.subjects,
      });
    case GET_ME_FAILED:
      return state
        .setIn(["userSession", "user"], "failed")
        .setIn(["allSubjects"], []);
    case FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_SUCCEEDED:
      let ministryOverviewDataObj = { ...action.payload };
      ministryOverviewDataObj.districts = [
        textIdentifier["All Districts"][
          state.userSession && state.userSession.user.language
        ],
        ...ministryOverviewDataObj.districts,
      ];
      return state.setIn(
        ["ministryDashboardOverviewData"],
        ministryOverviewDataObj
      );
    case FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED:
      return state.setIn(["ministryDashboardOverviewData"], undefined);

    case FETCH_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(["teacherEngagementCount"], action.payload);
    case FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(["teacherEngagementCount"], undefined);
    case FETCH_TEACHER_ENGAGEMENT_DATA_SUCCEEDED:
      return state.setIn(["teacherEngagementData"], action.payload.data);
    case FETCH_TEACHER_ENGAGEMENT_DATA_FAILED:
      return state.setIn(["teacherEngagementData"], []);

    case FETCH_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(["studentEngagementCount"], action.payload);
    case FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(["studentEngagementCount"], undefined);
    case FETCH_STUDENT_ENGAGEMENT_DATA_SUCCEEDED:
      return state.setIn(["studentEngagementData"], action.payload.data);
    case FETCH_STUDENT_ENGAGEMENT_DATA_FAILED:
      return state.setIn(["studentEngagementData"], []);

    case FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["studentProficientLvlThreeCount"], action.payload)
        : state.setIn(["studentProficientLvlTwoCount"], action.payload);
    case FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED:
      return action.round == 2 ? 
        state.setIn(["studentProficientLvlThreeCount"], undefined):
        state.setIn(["studentProficientLvlTwoCount"], undefined);
    case FETCH_STUDENT_PROFICIENT_LVL_2_DATA_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentProficientLvlThreeData"], action.payload.data):  
        state.setIn(["studentProficientLvlTwoData"], action.payload.data);
    case FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED:
      return action.round == 2 ?
        state.setIn(["studentProficientLvlThreeData"], []):
        state.setIn(["studentProficientLvlTwoData"], []);
    case FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["ministryQuestionsAttemptCount2"], action.payload):
        state.setIn(["ministryQuestionsAttemptCount"], action.payload);
    case FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED:
      return action.round == 2
        ? state.setIn(["ministryQuestionsAttemptCount2"], undefined)
        : state.setIn(["ministryQuestionsAttemptCount"], action.payload);
    case FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["ministryQuestionsAttemptData2"], action.payload.data)
        : state.setIn(["ministryQuestionsAttemptData"], action.payload.data);
    case FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED:
      return action.round == 2
        ? state.setIn(["ministryQuestionsAttemptData2"], [])
        : state.setIn(["ministryQuestionsAttemptData"], []);
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["ministryStudentImprovementCount2"], action.payload)
        : state.setIn(["ministryStudentImprovementCount"], action.payload);
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED:
      return action.round == 2
        ? state.setIn(["ministryStudentImprovementCount2"], undefined)
        : state.setIn(["ministryStudentImprovementCount"], undefined);
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["ministryStudentImprovementData2"], action.payload.data)
        : state.setIn(["ministryStudentImprovementData"], action.payload.data);
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED:
      return action.round == 2
        ? state.setIn(["ministryStudentImprovementData2"],[])
        : state.setIn(["ministryStudentImprovementData"], []);

    case FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED:
      return state.setIn(
        ["teacherEngagementPercentageTableData"],
        action.payload
      );

    case FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED:
      return state.setIn(["teacherEngagementPercentageTableData"], undefined);

    case FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_SUCCEEDED:
      return state.setIn(["teacherEngagementHoursTableData"], action.payload);

    case FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED:
      return state.setIn(["teacherEngagementHoursTableData"], undefined);

    case FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED:
      return state.setIn(
        ["studentEngagementPercentageTableData"],
        action.payload
      );

    case FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED:
      return state.setIn(["studentEngagementPercentageTableData"], undefined);

    case FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_SUCCEEDED:
      return state.setIn(["studentEngagementHoursTableData"], action.payload);

    case FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED:
      return state.setIn(["studentEngagementHoursTableData"], undefined);

    case FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentProficientLvlTwoPercentTableData2"], action.payload): 
        state.setIn(
        ["studentProficientLvlTwoPercentTableData"],
        action.payload
      );

    case FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentProficientLvlTwoPercentTableData2"], undefined):
        state.setIn(
        ["studentProficientLvlTwoPercentTableData"],
        undefined
      );

    case FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentProficientLvlTwoNumberTableData2"], action.payload):
        state.setIn(
          ["studentProficientLvlTwoNumberTableData"],
          action.payload
        );

    case FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentProficientLvlTwoNumberTableData2"], undefined): 
      state.setIn(["studentProficientLvlTwoNumberTableData"], undefined);

    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["ministryStudentImprovementPercentageTableData2"], action.payload):
        state.setIn(
        ["ministryStudentImprovementPercentageTableData"],
        action.payload
      );
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["ministryStudentImprovementPercentageTableData2"], undefined):
        state.setIn(
        ["ministryStudentImprovementPercentageTableData"],
        undefined
      );
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["ministryStudentImprovementNumberTableData2"], action.payload):
        state.setIn(
        ["ministryStudentImprovementNumberTableData"],
        action.payload
      );
    case FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["ministryStudentImprovementNumberTableData2"], undefined):
        state.setIn(
        ["ministryStudentImprovementNumberTableData"],
        undefined
      );
    case FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["ministryQuestionsAttemptedTableData2"], action.payload): 
        state.setIn(
          ["ministryQuestionsAttemptedTableData"],
          action.payload
        );

    case FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["ministryQuestionsAttemptedTableData2"], undefined):
        state.setIn(["ministryQuestionsAttemptedTableData"], undefined);
    case FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_SUCCEEDED:
      let studentOverviewDataObj = { ...action.payload };
      studentOverviewDataObj.classes = [
        {
          name: textIdentifier["All Classes"][
            state.userSession && state.userSession.user.language
          ],
          code: "",
        },
        ...studentOverviewDataObj.classes,
      ];
      return state.setIn(
        ["studentDashboardOverviewData"],
        studentOverviewDataObj
      );
    case FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED:
      return state.setIn(["studentDashboardOverviewData"], undefined);
    case FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_SUCCEEDED: {
      let studentOverviewDataRoundTwoObj = { ...action.payload };
      return state.setIn(
        ["studentDashboardOverviewDataRoundTwo"],
        studentOverviewDataRoundTwoObj
      );
    }
    case FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED:
      return state.setIn(["studentDashboardOverviewData"], undefined);
    case FETCH_STUDENT_TIME_CHART_DATA_SUCCEEDED:
      return state.setIn(["studentTimeChartData"], action.payload);
    case FETCH_STUDENT_TIME_CHART_DATA_FAILED:
      return state.setIn(["studentTimeChartData"], []);
    //in action.round there is 2. so action.round == 2 ? round 2 data : round 1 data
    case FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["studentQuestionsCompletedChartDataRoundTwo"],action.payload)
        : state.setIn(["studentQuestionsCompletedChartData"], action.payload);
    case FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED:
      return action.round == 2
        ? state.setIn(["studentQuestionsCompletedChartDataRoundTwo"], [])
        : state.setIn(["studentQuestionsCompletedChartData"], []);
    // return state.setIn(["studentQuestionsCompletedChartData"], []);
    case FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["studentImprovementChartDataRoundTwo"], action.payload)
        : state.setIn(["studentImprovementChartData"], action.payload);
    // return state.setIn(["studentImprovementChartData"], action.payload);
    case FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED:
      return action.round == 2
        ? state.setIn(["studentImprovementChartDataRoundTwo"], [])
        : state.setIn(["studentImprovementChartData"], []);
    // return state.setIn(["studentImprovementChartData"], []);
    case FETCH_STUDENT_TIME_DATA_SUCCEEDED:
      return state.setIn(["studentTimeData"], action.payload);
    case FETCH_STUDENT_TIME_DATA_FAILED:
      return state.setIn(["studentTimeData"], undefined);
    case FETCH_STUDENT_QUESTION_COMPLETION_DATA_SUCCEEDED:
      return action.round == 2
      ? state.setIn(["studentQuestionCompletionDataRoundTwo"], action.payload)
      : state.setIn(["studentQuestionCompletionData"], action.payload);
    case FETCH_STUDENT_IMPROVEMENT_DATA_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["studentImprovementDataRoundTwo"], action.payload)
        : state.setIn(["studentImprovementData"], action.payload);
    case FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentDetailedImprovementDataRoundTwo"], action.payload)
      : state.setIn(["studentDetailedImprovementData"], action.payload);
    case SET_CURRENT_QUESTION_VIEW_EXERCISE:
      const exerciseObj = {
        exercise: action.exercise,
        tryCount: action.tryCount,
      };
      return state.setIn(["currentQuestionViewExercise"], exerciseObj);
    case SET_CURRENT_QUESTION_VIEW_STUDENT:
      const studentObj = {
        id: action.id,
        name: action.name,
      };
      return state.setIn(["currentQuestionViewStudent"], studentObj);
    case SET_CURRENT_QUESTION_VIEW_STUDENT_CLASS:
      const classObj = {
        name: action.class_name,
        code: action.class_code,
      };
      return state.setIn(["currentQuestionViewStudentClass"], classObj);
    case FETCH_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED:
      const questionResponsePractice = action.data;
      const reportQuestionPractice = {};

      reportQuestionPractice.id = questionResponsePractice.question_id;
      if (questionResponsePractice.question)
        reportQuestionPractice.question = b64DecodeUnicode(
          questionResponsePractice.question
        );
      if (questionResponsePractice.answer_type)
        reportQuestionPractice.answerType = b64DecodeUnicode(
          questionResponsePractice.answer_type
        );
      reportQuestionPractice.userResponse =
        null ||
        (questionResponsePractice.hasOwnProperty("user_response") &&
        questionResponsePractice.user_response !== null &&
        questionResponsePractice.user_response !== "[]"
          ? typeof questionResponsePractice.user_response === "string"
            ? questionResponsePractice.user_response_ui
            : questionResponsePractice.user_response
          : null);
      reportQuestionPractice.userResponseState =
        reportQuestionPractice.userResponse ? true : false;
      reportQuestionPractice.valid_response =
        questionResponsePractice.valid_respone;
      reportQuestionPractice.percentage = questionResponsePractice.percentage;
      return state.setIn(
        ["studentReportQuestions", action.index],
        reportQuestionPractice
      );

    case FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED:
      const questionResponse = action.data;
      const reportQuestion = {};

      reportQuestion.id = questionResponse.question_id;
      if (questionResponse.question)
        reportQuestion.question = b64DecodeUnicode(questionResponse.question);
      if (questionResponse.answer_type)
        reportQuestion.answerType = b64DecodeUnicode(
          questionResponse.answer_type
        );
      reportQuestion.userResponse =
        null ||
        (questionResponse.hasOwnProperty("user_response") &&
        questionResponse.user_response !== null &&
        questionResponse.user_response !== "[]"
          ? typeof questionResponse.user_response === "string"
            ? questionResponse.user_response_ui
            : questionResponse.user_response
          : null);
      reportQuestion.userResponseState = reportQuestion.userResponse
        ? true
        : false;
      reportQuestion.valid_response = questionResponse.valid_respone;
      reportQuestion.percentage = questionResponse.percentage;
      return state.setIn(
        ["studentReportQuestions", action.index],
        reportQuestion
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED:
      const questionResponsePracticeTeacher = action.data;
      const reportQuestionPracticeTeacher = {};

      reportQuestionPracticeTeacher.id =
        questionResponsePracticeTeacher.question_id;
      if (questionResponsePracticeTeacher.question)
        reportQuestionPracticeTeacher.question = b64DecodeUnicode(
          questionResponsePracticeTeacher.question
        );
      if (questionResponsePracticeTeacher.answer_type)
        reportQuestionPracticeTeacher.answerType = b64DecodeUnicode(
          questionResponsePracticeTeacher.answer_type
        );
      reportQuestionPracticeTeacher.userResponse =
        null ||
        (questionResponsePracticeTeacher.hasOwnProperty("user_response") &&
        questionResponsePracticeTeacher.user_response !== null &&
        questionResponsePracticeTeacher.user_response !== "[]"
          ? typeof questionResponsePracticeTeacher.user_response === "string"
            ? questionResponsePracticeTeacher.user_response_ui
            : questionResponsePracticeTeacher.user_response
          : null);
      reportQuestionPracticeTeacher.userResponseState =
        reportQuestionPracticeTeacher.userResponse ? true : false;
      reportQuestionPracticeTeacher.valid_response =
        questionResponsePracticeTeacher.valid_respone;
      reportQuestionPracticeTeacher.percentage =
        questionResponsePracticeTeacher.percentage;
      return state
        .setIn(
          ["studentReportQuestions", action.index],
          reportQuestionPracticeTeacher
        )
        .setIn(
          ["isLastReportQuestion"],
          action.index === action.total_attempts - 1
        );

    case FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED:
      const questionResponseImprovement = action.data;
      const reportQuestionImprovement = {};

      reportQuestionImprovement.id = questionResponseImprovement.question_id;
      if (questionResponseImprovement.question)
        reportQuestionImprovement.question = b64DecodeUnicode(
          questionResponseImprovement.question
        );
      if (questionResponseImprovement.answer_type)
        reportQuestionImprovement.answerType = b64DecodeUnicode(
          questionResponseImprovement.answer_type
        );
      reportQuestionImprovement.userResponse =
        null ||
        (questionResponseImprovement.hasOwnProperty("user_response") &&
        questionResponseImprovement.user_response !== null &&
        questionResponseImprovement.user_response !== "[]"
          ? typeof questionResponseImprovement.user_response === "string"
            ? questionResponseImprovement.user_response_ui
            : questionResponseImprovement.user_response
          : null);
      reportQuestionImprovement.userResponseState =
        reportQuestionImprovement.userResponse ? true : false;
      reportQuestionImprovement.valid_response =
        questionResponseImprovement.valid_respone;
      reportQuestionImprovement.percentage =
        questionResponseImprovement.percentage;
      return state
        .setIn(
          ["studentReportQuestions", action.index],
          reportQuestionImprovement
        )
        .setIn(
          ["isLastReportQuestion"],
          action.index === action.total_attempts - 1
        );
    case EXIT_DASHBOARD_QUESTION_VIEW:
      return state
        .setIn(["studentReportQuestions"], undefined)
        .setIn(["currentQuestionViewExercise"], undefined)
        .setIn(["isLastReportQuestion"], undefined);
    case RESET_CURRENT_QUESTION_VIEW_STUDENT:
      return state.setIn(["currentQuestionViewStudent"], undefined);
    case RESET_CURRENT_QUESTION_VIEW_STUDENT_CLASS:
      return state.setIn(["currentQuestionViewStudentClass"], undefined);
    case FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_SUCCEEDED:
      let teacherOverviewDataObj = { ...action.payload };
      teacherOverviewDataObj.teacher_classes = [
        {
          name: textIdentifier["All Classes"][
            state.userSession && state.userSession.user.language
          ],
          code: "",
        },
        ...teacherOverviewDataObj.teacher_classes,
      ];
      return state.setIn(
        ["teacherDashboardOverviewData"],
        teacherOverviewDataObj
      );
    case FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED:
      return state.setIn(["teacherDashboardOverviewData"], undefined);

    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardNationwideStudentEngagementCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(
        ["teacherDashboardNationwideStudentEngagementCount"],
        undefined
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardNationwideStudentEngagementChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED:
      return state.setIn(
        ["teacherDashboardNationwideStudentEngagementChart"],
        []
      );

    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlTwoCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlTwoCount"],
        undefined
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlTwoChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlTwoChart"],
        []
      );

    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlThreeCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlThreeCount"],
        undefined
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlThreeChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED:
      return state.setIn(
        ["teacherDashboardNationwideStudentProfLvlThreeChart"],
        []
      );

    case FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardStudentEngagementCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(["teacherDashboardStudentEngagementCount"], undefined);
    case FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardStudentEngagementChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED:
      return state.setIn(["teacherDashboardStudentEngagementChart"], []);

    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTwentyQuestionsCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTwentyQuestionsCount"],
        undefined
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTwentyQuestionsChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTwentyQuestionsChart"],
        []
      );

    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTenQuestionsCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTenQuestionsCount"],
        undefined
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTenQuestionsChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED:
      return state.setIn(
        ["teacherDashboardStudentCompletedTenQuestionsChart"],
        []
      );

    case FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentProfLvlTwoCountRoundTwo"], action.payload):
        state.setIn(
          ["teacherDashboardStudentProfLvlTwoCount"],
          action.payload
        );
    case FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentProfLvlTwoCountRoundTwo"], undefined):
      state.setIn(["teacherDashboardStudentProfLvlTwoCount"], undefined);
    case FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentProfLvlTwoChartRoundTwo"], action.payload):
        state.setIn(
          ["teacherDashboardStudentProfLvlTwoChart"],
          action.payload
        );
    case FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentProfLvlTwoChartRoundTwo"], []): 
        state.setIn(["teacherDashboardStudentProfLvlTwoChart"], []);

    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentImprovementCountRoundTwo"], action.payload):
      state.setIn(
        ["teacherDashboardStudentImprovementCount"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentImprovementCountRoundTwo"], undefined): 
      state.setIn(
        ["teacherDashboardStudentImprovementCount"],
        undefined
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentImprovementChartRoundTwo"], action.payload):
      state.setIn(
        ["teacherDashboardStudentImprovementChart"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentImprovementChartRoundTwo"], []):  
      state.setIn(["teacherDashboardStudentImprovementChart"], []);

    case FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED:
      return state.setIn(["studentTimeData"], action.payload);

    case FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED:
      return state.setIn(["studentTimeData"], undefined);

    case FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentQuestionCompletionDataRoundTwo"], action.payload): 
        state.setIn(["studentQuestionCompletionData"], action.payload);

    case FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentQuestionCompletionDataRoundTwo"], undefined): 
        state.setIn(["studentQuestionCompletionData"], undefined);

    case FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentProfLvlTwoTableRoundTwo"], action.payload):
      state.setIn(
        ["teacherDashboardStudentProfLvlTwoTable"],
        action.payload
      );

    case FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardStudentProfLvlTwoTableRoundTwo"], undefined):   
      state.setIn(["teacherDashboardStudentProfLvlTwoTable"], undefined);

    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED:
      return action.round == 2 ?
      state.setIn(["studentImprovementDataRoundTwo"], action.payload):   
      state.setIn(["studentImprovementData"], action.payload);

    case FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentImprovementDataRoundTwo"], undefined):   
      state.setIn(["studentImprovementData"], undefined);

    case FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentDetailedImprovementDataRoundTwo"], action.payload):   
      state.setIn(["studentDetailedImprovementData"], action.payload);

    case FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentDetailedImprovementDataRoundTwo"], undefined):   
      state.setIn(["studentDetailedImprovementData"], undefined);

    case FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardQuestionAnalysisTopicsRoundTwo"], action.payload):
        state.setIn(
          ["teacherDashboardQuestionAnalysisTopics"],
          action.payload
        );
    case FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardQuestionAnalysisTopicsRoundTwo"], []):   
        state.setIn(["teacherDashboardQuestionAnalysisTopics"], []);
    case FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardQuestionAnalysisChartRoundTwo"], action.payload):
        state.setIn(
          ["teacherDashboardQuestionAnalysisChart"],
          action.payload
        );

    case FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardQuestionAnalysisChartRoundTwo"], []):
        state.setIn(["teacherDashboardQuestionAnalysisChart"], []);

    case FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardQuestionAnalysisTableRoundTwo"], action.payload):
      state.setIn(
        ["teacherDashboardQuestionAnalysisTable"],
        action.payload
      );
    case FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["teacherDashboardQuestionAnalysisTableRoundTwo"], undefined):  
        state.setIn(["teacherDashboardQuestionAnalysisTable"], undefined);
    case EXIT_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE:
      return state
        .setIn(["teacherDashboardQuestionAnalysisTopics"], [])
        .setIn(["teacherDashboardQuestionAnalysisTopicsRoundTwo"], []);
                  
    case FETCH_STUDENT_LIST_DROPDOWN_SUCCEEDED:
      return action.round == 2
        ? state.setIn(["teacherDashboardStudentListDropdownRoundTwo"], action.payload.students) 
        : state.setIn(
            ["teacherDashboardStudentListDropdown"],
            action.payload.students
          );

    case FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_SUCCEEDED:
      let principalOverviewDataObj = { ...action.payload };
      principalOverviewDataObj.principal_classes = [
        {
          name: textIdentifier["All Classes"][
            state.userSession && state.userSession.user.language
          ],
          code: "",
        },
        ...principalOverviewDataObj.principal_classes,
      ];
      return state.setIn(
        ["principalDashboardOverviewData"],
        principalOverviewDataObj
      );
    case FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED:
      return state.setIn(["principalDashboardOverviewData"], undefined);

    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideTeacherEngagementCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardNationwideTeacherEngagementCount"],
        undefined
      );

    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideTeacherEngagementChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED:
      return state.setIn(
        ["principalDashboardNationwideTeacherEngagementChart"],
        []
      );

    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideStudentEngagementCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardNationwideStudentEngagementCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideStudentEngagementChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED:
      return state.setIn(
        ["principalDashboardNationwideStudentEngagementChart"],
        []
      );

    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlTwoCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlTwoCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlTwoChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlTwoChart"],
        []
      );

    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlThreeCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlThreeCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlThreeChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED:
      return state.setIn(
        ["principalDashboardNationwideStudentProfLvlThreeChart"],
        []
      );

    case FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardTeacherEngagementCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardTeacherEngagementCount"],
        undefined
      );

    case FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardTeacherEngagementChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED:
      return state.setIn(["principalDashboardTeacherEngagementChart"], []);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentEngagementCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardStudentEngagementCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentEngagementChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED:
      return state.setIn(["principalDashboardStudentEngagementChart"], []);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentCompletedTwentyQuestionsCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardStudentCompletedTwentyQuestionsCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentCompletedTwentyQuestionsChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED:
      return state.setIn(
        ["principalDashboardStudentCompletedTwentyQuestionsChart"],
        []
      );

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentCompletedTenQuestionsCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED:
      return state.setIn(
        ["principalDashboardStudentCompletedTenQuestionsCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentCompletedTenQuestionsChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED:
      return state.setIn(
        ["principalDashboardStudentCompletedTenQuestionsChart"],
        []
      );

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentProfLvlTwoCountRoundTwo"], action.payload): 
        state.setIn(
        ["principalDashboardStudentProfLvlTwoCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentProfLvlTwoCountRoundTwo"], undefined):
      state.setIn(
        ["principalDashboardStudentProfLvlTwoCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentProfLvlTwoChartRoundTwo"], action.payload):
      state.setIn(
        ["principalDashboardStudentProfLvlTwoChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentProfLvlTwoChartRoundTwo"], []): 
      state.setIn(["principalDashboardStudentProfLvlTwoChart"], []);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED:
      return action.round == 2 ?
      state.setIn(["principalDashboardStudentImprovementCountRoundTwo"], action.payload):
      state.setIn(
        ["principalDashboardStudentImprovementCount"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentImprovementCountRoundTwo"], undefined):
      state.setIn(
        ["principalDashboardStudentImprovementCount"],
        undefined
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentImprovementChartRoundTwo"], action.payload):
      state.setIn(
        ["principalDashboardStudentImprovementChart"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentImprovementChartRoundTwo"], []):
      state.setIn(["principalDashboardStudentImprovementChart"], []);
    case FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_SUCCEEDED:
      return state.setIn(
        ["principalDashboardTeacherHoursTable"],
        action.payload
      );

    case FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED:
      return state.setIn(["principalDashboardTeacherHoursTable"], undefined);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED:
      return state.setIn(["studentTimeData"], action.payload);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED:
      return state.setIn(["studentTimeData"], undefined);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentQuestionCompletionDataRoundTwo"], action.payload): 
        state.setIn(["studentQuestionCompletionData"], action.payload);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentQuestionCompletionDataRoundTwo"], undefined):  
        state.setIn(["studentQuestionCompletionData"], undefined);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentProfLvlTwoTableRoundTwo"], action.payload) :
        state.setIn(
        ["principalDashboardStudentProfLvlTwoTable"],
        action.payload
      );

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardStudentProfLvlTwoTableRoundTwo"], undefined): 
        state.setIn(
          ["principalDashboardStudentProfLvlTwoTable"],
          undefined
        );

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentImprovementDataRoundTwo"], action.payload) : 
        state.setIn(["studentImprovementData"], action.payload);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentImprovementDataRoundTwo"], undefined): 
        state.setIn(["studentImprovementData"], undefined);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["studentDetailedImprovementDataRoundTwo"], action.payload): 
        state.setIn(["studentDetailedImprovementData"], action.payload);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["studentDetailedImprovementDataRoundTwo"], undefined): 
        state.setIn(["studentDetailedImprovementData"], undefined);

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED:
      const questionResponsePracticePrincipal = action.data;
      const reportQuestionPracticePrincipal = {};

      reportQuestionPracticePrincipal.id =
        questionResponsePracticePrincipal.question_id;
      if (questionResponsePracticePrincipal.question)
        reportQuestionPracticePrincipal.question = b64DecodeUnicode(
          questionResponsePracticePrincipal.question
        );
      if (questionResponsePracticePrincipal.answer_type)
        reportQuestionPracticePrincipal.answerType = b64DecodeUnicode(
          questionResponsePracticePrincipal.answer_type
        );
      reportQuestionPracticePrincipal.userResponse =
        null ||
        (questionResponsePracticePrincipal.hasOwnProperty("user_response") &&
        questionResponsePracticePrincipal.user_response !== null &&
        questionResponsePracticePrincipal.user_response !== "[]"
          ? typeof questionResponsePracticePrincipal.user_response === "string"
            ? questionResponsePracticePrincipal.user_response_ui
            : questionResponsePracticePrincipal.user_response
          : null);
      reportQuestionPracticePrincipal.userResponseState =
        reportQuestionPracticePrincipal.userResponse ? true : false;
      reportQuestionPracticePrincipal.valid_response =
        questionResponsePracticePrincipal.valid_respone;
      reportQuestionPracticePrincipal.percentage =
        questionResponsePracticePrincipal.percentage;
      return state.setIn(
        ["studentReportQuestions", action.index],
        reportQuestionPracticePrincipal
      );

    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED:
      const questionResponseImprovementPrincipal = action.data;
      const reportQuestionImprovementPrincipal = {};

      reportQuestionImprovementPrincipal.id =
        questionResponseImprovementPrincipal.question_id;
      if (questionResponseImprovementPrincipal.question)
        reportQuestionImprovementPrincipal.question = b64DecodeUnicode(
          questionResponseImprovementPrincipal.question
        );
      if (questionResponseImprovementPrincipal.answer_type)
        reportQuestionImprovementPrincipal.answerType = b64DecodeUnicode(
          questionResponseImprovementPrincipal.answer_type
        );
      reportQuestionImprovementPrincipal.userResponse =
        null ||
        (questionResponseImprovementPrincipal.hasOwnProperty("user_response") &&
        questionResponseImprovementPrincipal.user_response !== null &&
        questionResponseImprovementPrincipal.user_response !== "[]"
          ? typeof questionResponseImprovementPrincipal.user_response ===
            "string"
            ? questionResponseImprovementPrincipal.user_response_ui
            : questionResponseImprovementPrincipal.user_response
          : null);
      reportQuestionImprovementPrincipal.userResponseState =
        reportQuestionImprovementPrincipal.userResponse ? true : false;
      reportQuestionImprovementPrincipal.valid_response =
        questionResponseImprovementPrincipal.valid_respone;
      reportQuestionImprovementPrincipal.percentage =
        questionResponseImprovementPrincipal.percentage;
      return state.setIn(
        ["studentReportQuestions", action.index],
        reportQuestionImprovementPrincipal
      );
    case FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED:
      return action.round == 2 ?
      state.setIn(["principalDashboardQuestionAnalysisTopicsRoundTwo"], action.payload) :
      state.setIn(
        ["principalDashboardQuestionAnalysisTopics"],
        action.payload
      );
    case FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardQuestionAnalysisTopicsRoundTwo"], []):
      state.setIn(["principalDashboardQuestionAnalysisTopics"], []);

    case FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["principalDashboardQuestionAnalysisChartRoundTwo"], action.payload) : 
      state.setIn(
        ["principalDashboardQuestionAnalysisChart"],
        action.payload
      );

    case FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardQuestionAnalysisChartRoundTwo"], []): 
      state.setIn(["principalDashboardQuestionAnalysisChart"], []);

    case FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED:
      return action.round == 2 ?
        state.setIn(["principalDashboardQuestionAnalysisTableRoundTwo"], action.payload) : 
        state.setIn(
          ["principalDashboardQuestionAnalysisTable"],
          action.payload
        );

    case FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED:
      return action.round == 2 ?
        state.setIn(["principalDashboardQuestionAnalysisTableRoundTwo"], undefined) :
        state.setIn(
          ["principalDashboardQuestionAnalysisTable"],
          undefined
        );
    case EXIT_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE:
      return state.setIn(["principalDashboardQuestionAnalysisTopics"], [])
                  .setIn(["principalDashboardQuestionAnalysisTopicsRoundTwo"], [])
    case FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_SUCCEEDED:
      return state.setIn(
        ["principalDashboardStudentListDropdown"],
        action.payload.students
      );
    case FETCH_DISTRICT_SCHOOLS_SUCCEEDED:
      return state.setIn(["districtSchools"], action.payload);
    case FETCH_DISTRICT_SCHOOLS_FAILED:
      return state.setIn(["districtSchools"], undefined);
    case FETCH_DISTRICTS_SUCCEEDED:
      return state.setIn(["districts"], action.payload);
    case FETCH_DISTRICTS_FAILED:
      return state.setIn(["districts"], undefined);
    case DOWNLOAD_DISTRICT_DATA_REQUESTED:
      return state
        .setIn(["downloadDistrictDataLoading"], true)
        .setIn(["downloadDistrictDataSuccess"], false)
        .setIn(["downloadDistrictDataError"], false);
    case DOWNLOAD_DISTRICT_DATA_SUCCEEDED:
      return state
        .setIn(["downloadDistrictDataLoading"], false)
        .setIn(["downloadDistrictDataSuccess"], true)
        .setIn(["downloadDistrictDataError"], false);
    case DOWNLOAD_DISTRICT_DATA_FAILED:
      return state
        .setIn(["downloadDistrictDataLoading"], false)
        .setIn(["downloadDistrictDataSuccess"], false)
        .setIn(["downloadDistrictDataError"], true);
    case DOWNLOAD_ALL_MOE_REPORTS_REQUESTED:
      return state
        .setIn(["downloadAllMoeReportsLoading"], true)
        .setIn(["downloadAllMoeReportsSuccess"], false)
        .setIn(["downloadAllMoeReportsError"], false);
    case DOWNLOAD_ALL_MOE_REPORTS_SUCCEEDED:
      return state
        .setIn(["downloadAllMoeReportsLoading"], false)
        .setIn(["downloadAllMoeReportsSuccess"], true)
        .setIn(["downloadAllMoeReportsError"], false);
    case DOWNLOAD_ALL_MOE_REPORTS_FAILED:
      return state
        .setIn(["downloadAllMoeReportsLoading"], false)
        .setIn(["downloadAllMoeReportsSuccess"], false)
        .setIn(["downloadAllMoeReportsError"], true);
    case DOWNLOAD_PAGINATION_DATA_REQUESTED:
      return state
        .setIn(["downloadPaginationDataLoading"], true)
        .setIn(["downloadPaginationDataSuccess"], false)
        .setIn(["downloadPaginationDataError"], false);
    case DOWNLOAD_PAGINATION_DATA_SUCCEEDED:
      return state
        .setIn(["downloadPaginationDataLoading"], false)
        .setIn(["downloadPaginationDataSuccess"], true)
        .setIn(["downloadPaginationDataError"], false);
    case DOWNLOAD_PAGINATION_DATA_FAILED:
      return state
        .setIn(["downloadPaginationDataLoading"], false)
        .setIn(["downloadPaginationDataSuccess"], false)
        .setIn(["downloadPaginationDataError"], true);
    case RESET_DOWNLOAD_PAGINATION_DATA:
      return state
        .setIn(["downloadPaginationDataLoading"], false)
        .setIn(["downloadPaginationDataSuccess"], false)
        .setIn(["downloadPaginationDataError"], false);
    default:
      return state;
  }
};
